import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BB_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#BB_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M22 0h10v24H22V0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement("path", { d: "M10 0h12v24H10V0z", fill: "#FECA00" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h10v24H0V0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.612 15.667c.188-1.29 1.52-4.092 1.52-4.092l.619-1.645-2.45.795.58.302-1.135 3.198-.856-.204V7.852l.677-.05-1.672-2.43-1.632 2.48h.787v6.169l-.965.161-.688-3.235.397-.333-2.665-.491.796 1.468s1.07 2.517 1.472 4.076l1.653-.127v2.397h1.84V15.54l1.722.127z",
      fill: "#000"
    }
  ))
);
export {
  t as default
};
